import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(no-auth)/games/error.tsx")